import { html } from '../lib/dom';
import type { PageState } from '../api/paged';

// Infinite scroll: a marker under a paged list loads the next page as it comes into view.
export function loadMoreMarker(state: PageState, label: string) {
  if (state.error) return html`<div class="row" data-load-more style="justify-content:center;padding:12px"><span class="muted">${state.error}</span><button class="btn sm" data-load-more-retry>Retry</button></div>`;
  if (state.done) return '';
  return html`<div class="muted" data-load-more aria-hidden="${state.loading ? 'false' : 'true'}" style="text-align:center;${state.loading ? 'padding:12px' : 'height:1px;overflow:hidden'}">${state.loading ? label : ''}</div>`;
}
export function bindLoadMore(root: HTMLElement, state: PageState, more: () => unknown): () => void {
  const marker = root.querySelector('[data-load-more]');
  if (!marker) return (): void => undefined;
  // A failed page waits for Retry instead of being requested again on every render.
  if (state.error) {
    const retry = () => { void more(); };
    const button = root.querySelector('[data-load-more-retry]');
    button?.addEventListener('click', retry);
    return () => button?.removeEventListener('click', retry);
  }
  const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) void more(); }, { rootMargin: '400px' });
  observer.observe(marker);
  return () => observer.disconnect();
}
